export default __webpack_public_path__ + "static/media/Loaf_iPhoneX_Search_Templates_11_19_21.7b246ea5.png";